var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3112 15.3C7.36634 15.3 4.18359 12.0724 4.18359 8.17239C4.18359 4.2724 7.36634 1 11.3112 1C15.256 1 18.4387 4.22758 18.4387 8.17239C18.4387 12.1172 15.256 15.3 11.3112 15.3ZM11.3112 1.89655C7.85944 1.89655 5.08014 4.72068 5.08014 8.17239C5.08014 11.6241 7.85944 14.4034 11.3112 14.4034C14.7629 14.4034 17.5422 11.6241 17.5422 8.17239C17.5422 4.72068 14.7629 1.89655 11.3112 1.89655Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.1723 27H1.44827C1.17931 27 1 26.8207 1 26.5517C1 22.9207 3.10689 19.6035 6.37929 18.0345C7.18619 17.6311 8.03791 17.3621 8.93446 17.2276C9.20342 17.1828 9.42756 17.3621 9.42756 17.5862C9.47238 17.8104 9.29308 18.0793 9.06894 18.0793C8.26204 18.2138 7.49998 18.438 6.78274 18.7966C3.95861 20.1414 2.12069 22.9655 1.94138 26.0586H20.7241C20.6344 23.9517 19.7379 21.9793 18.2586 20.5C17.5862 19.8276 16.7793 19.2449 15.8827 18.8414C15.1655 18.4828 14.3586 18.2586 13.5965 18.1242C13.3724 18.0793 13.1931 17.8552 13.2379 17.6311C13.2827 17.4069 13.5069 17.2276 13.731 17.2724C14.5827 17.4069 15.4793 17.6759 16.2862 18.0793C17.2724 18.5276 18.1241 19.1552 18.8861 19.9173C20.6792 21.7104 21.6654 24.0414 21.6654 26.5517C21.6206 26.7759 21.4413 27 21.1723 27Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.78522 22.1137C9.65074 22.1137 9.56109 22.0689 9.47143 21.9792L6.24386 18.7517C6.1542 18.662 6.10938 18.4827 6.10938 18.3482C6.1542 18.2137 6.24386 18.0793 6.37834 18.0344C7.18523 17.631 8.03696 17.362 8.9335 17.2275C9.06799 17.2275 9.20247 17.2724 9.33695 17.362L11.668 19.693C11.7576 19.7827 11.8025 19.8724 11.8025 20.0068C11.8025 20.0517 11.8025 20.0517 11.8025 20.0965C11.8025 20.1413 11.8025 20.1413 11.8025 20.1861C11.8025 20.3206 11.7576 20.4103 11.668 20.4999L10.1438 22.0241C10.0094 22.0689 9.91971 22.1137 9.78522 22.1137ZM7.31972 18.5724L9.78522 21.0379L10.7266 20.0965L8.79902 18.1689C8.30592 18.2586 7.81282 18.3931 7.31972 18.5724Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.8357 22.1137C12.7012 22.1137 12.6116 22.0689 12.5219 21.9792L10.9978 20.4551C10.9081 20.4103 10.8633 20.2758 10.8633 20.1861C10.8633 20.1413 10.8633 20.1413 10.8633 20.0965C10.8633 20.0517 10.8633 20.0517 10.8633 20.0068C10.8633 19.8724 10.9081 19.7827 10.9978 19.693L13.3288 17.362C13.4184 17.2724 13.5529 17.2275 13.7322 17.2275C14.584 17.362 15.4805 17.631 16.2874 18.0344C16.4219 18.0793 16.5115 18.2137 16.5564 18.3482C16.6012 18.4827 16.5564 18.6172 16.4219 18.7517L13.1943 21.9792C13.0598 22.0689 12.9253 22.1137 12.8357 22.1137ZM11.8943 20.0965L12.8357 21.0379L15.3012 18.5724C14.8081 18.3931 14.315 18.2586 13.8219 18.1689L11.8943 20.0965Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5521 26.9997H9.06938C8.93489 26.9997 8.80041 26.9549 8.71076 26.8653C8.6211 26.7756 8.57627 26.6411 8.6211 26.5066L9.33834 21.6205C9.33834 21.5308 9.38317 21.4411 9.47282 21.3515L10.997 19.8274C11.1763 19.648 11.4452 19.648 11.6245 19.8274L13.1487 21.3515C13.2383 21.4411 13.2832 21.486 13.2832 21.6205L14.0004 26.4618C14.0004 26.5963 14.0004 26.7308 13.9107 26.8204C13.8211 26.9101 13.6866 26.9997 13.5521 26.9997ZM9.60731 26.1032H13.059L12.4314 21.8894L11.3107 20.8136L10.2349 21.8894L9.60731 26.1032Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/student-icon.38a008524ec888193ceaa026539cb25b.svg";
export { ForwardRef as ReactComponent };